// extracted by mini-css-extract-plugin
var _1 = "BirdviewAttentionRowHeader-moduleheader__voE8d";
var _2 = "BirdviewAttentionRowHeader-modulereason__gk3gO";
var _3 = "BirdviewAttentionRowHeader-moduletoggle__Q2t_r";
export { _1 as "header", _2 as "reason", _3 as "toggle" }
